import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationState } from '../store/auth/auth.state';
import { UserRole } from '../model';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationState);
  const router = inject(Router);

  if (auth.isAuthenticated) {
    return true;
  }
  return router.createUrlTree(['/welcome']);
};

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationState);
  const router = inject(Router);

  if (auth.isAuthenticated && auth.hasAnyRole(UserRole.Admin)) {
    return true;
  }
  return router.createUrlTree(auth.isAuthenticated ? ['/home'] : ['/welcome']);
};

export const welcomeGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationState);
  const router = inject(Router);

  // If already authenticated, skip welcome and go straight to app
  if (auth.isAuthenticated) {
    return router.createUrlTree(['/home']);
  }
  return true;
};
